exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-page[data-v-bb9a4aee] {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding-top: 0.104167rem;\n  background: #f3f3f3;\n  box-sizing: border-box;\n}\n.error-code span[data-v-bb9a4aee] {\n  color: #a172a9;\n}\n.error-desc[data-v-bb9a4aee] {\n  margin-left: 0.520833rem;\n  margin-right: 0.520833rem;\n  font-size: 0.09375rem;\n  color: rgba(24, 151, 231, 1);\n}\n.error-desc div[data-v-bb9a4aee] {\n  white-space: pre-wrap;\n}\n.link-pointer[data-v-bb9a4aee] {\n  text-decoration: underline;\n  color: rgb(65, 138, 179);\n  font-weight: bolder;\n  cursor: pointer;\n}", ""]);

// exports
